import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { UserRole } from '@pcmp-checka/lib-utilities/atkomst';

import {
  GetCurrentSessionResponse,
  GetUserProfileResponse,
} from '@/typings/api';
import { getInvitationToken } from '@/lib/utils/invitations';

export type SetSessionAction = PayloadAction<GetCurrentSessionResponse>;
export type SetRolesAction = PayloadAction<UserRole[]>;
export type SetProfileAction = PayloadAction<GetUserProfileResponse>;
export type SetIsManagerAction = PayloadAction<boolean>;

type SessionState = {
  isManager?: boolean;
  profile?: GetUserProfileResponse;
  roles?: UserRole[];
  session?: GetCurrentSessionResponse;
  invitationToken?: string;
};

const defaultInitialState: SessionState = {
  session: undefined,
  roles: undefined,
  invitationToken: getInvitationToken(),
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState: defaultInitialState,
  reducers: {
    setSession(state, action: SetSessionAction) {
      state.session = action.payload;
    },
    setRoles(state, action: SetRolesAction) {
      state.roles = action.payload;
    },
    setProfile(state, action: SetProfileAction) {
      state.profile = action.payload;
    },
    setIsManager(state, action: SetIsManagerAction) {
      state.isManager = action.payload;
    },
    reset() {
      return { ...defaultInitialState };
    },
  },
});

export const { setSession, setRoles, setProfile, setIsManager } =
  sessionSlice.actions;

export default sessionSlice.reducer;
